/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
// Copyright 2021 channysok
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
//     http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React, {useEffect, useState, useCallback} from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faUser, faBarcode, faPhone, faAddressCard, faHome, faPeopleArrows, faCode, faSave, faUnlockAlt } from "@fortawesome/free-solid-svg-icons"
import { Badge, Breadcrumb, Button, Card, Col, ProgressBar, Row, Table, Dropdown, ButtonGroup, Form, InputGroup } from '@themesberg/react-bootstrap'
import _, { result } from 'lodash'
import { useDispatch, useSelector } from "react-redux"
import ReceiverAction from '../../core/redux/action/ReceiverAction'
import UserAction from '../../core/redux/action/UserAction'
import Progress from "../../components/Progress"
import { GetResultObject, PostRequest } from '../../core/API'
import { ApiSrc } from '../../resources/ApiSrc'

export default (props) => {

    const [firstName, setFirstName] = useState()
    const [lastName, setLastName] = useState()
    const [sex, setSex] = useState()
    const [phone, setPhone] = useState()
    const [wrongPhone, setWrongPhone] = useState()        
    const [countryCode, setCountryCode] = useState('855')
    const [role, setRole] = useState('Admin')    
    const [password, setPassword] = useState()    
    const [username, setUsername] = useState()    
    const dispatch = useDispatch();
    const [progressValue, setProgressValue] = useState();

    const escFunction = useCallback((event) => {
        if(event.keyCode === 27) {        
          props.onClose && props.onClose()
        }
      }, [props]);
    
      useEffect(() => {
        document.addEventListener("keydown", escFunction, false);
        return () => {
          document.removeEventListener("keydown", escFunction, false);
        };
    }, [escFunction]);

    const onSave = () => {
        const body = {            
            firstName,
            lastName,
            sex,
            phone,
            countryCode,
            username,   
            role, 
            password,                  
        }

        console.log('>> body', body)
        setProgressValue(30)
        PostRequest(ApiSrc.CREATE_USER, {input: {...body}, token: null}).then(result =>            
            GetResultObject(result, 'data', 200, (data) => {
                setProgressValue(100)
                dispatch(UserAction.createUserSuccess(data));                  
                let timer = setInterval(function(){ 
                    props.onClose && props.onClose(timer)
                }, 1000);
            })
        )
        //dispatch(UserAction.createUser({input: {...body}, token: null}));        
        // setInterval(function(){ 
        //     props.onClose && props.onClose()
        // }, 3500);        
    }

    const onPhoneChange = (e) => {        
        var value = e.target.value        
        const reg = /^[1-9][0-9]\d{3}\d{3}/;        
        if (reg.test(value) === false) {   
            console.log(">reg false", value)         
            setPhone(value == "" ? undefined : value)
            setWrongPhone(value == "" ? undefined : "Invalid Phone")
            return false;
        } else {
            console.log(">reg true", value)
            setWrongPhone(undefined)
            setPhone(value)
            return true;
        }
    }
    
    return (
        <>            
          {
            progressValue !== undefined && (<Progress variant="success" label="Progress..." value={progressValue ?? 1} />)
          }
            <Card>             
                <Card.Body>
                    <Form>                        
                        <Row>
                            <Col xs={12} sm={12} xl={6}>
                                <Row>
                                    <Col>    
                                        <Col>
                                            <Form.Label>First Name</Form.Label>
                                        </Col>                            
                                        <Col>                                    
                                            <InputGroup>
                                                <InputGroup.Text >                                            
                                                    <FontAwesomeIcon icon={faUser} />
                                                </InputGroup.Text>
                                                <Form.Control autoFocus required type="text" 
                                                    onChange={(e)=>setFirstName(e.target.value)}
                                                />
                                            </InputGroup>
                                        </Col>
                                    </Col>                                                        
                                    <Col>                             
                                        <Col>
                                            <Form.Label>Last Name</Form.Label>
                                        </Col>                            
                                        <Col>
                                            <InputGroup>
                                                <InputGroup.Text >                                            
                                                    <FontAwesomeIcon icon={faUser} />
                                                </InputGroup.Text>
                                                <Form.Control autoFocus required type="text"                                                     
                                                    onChange={(e)=>setLastName(e.target.value)}/>
                                            </InputGroup>
                                        </Col>                                       
                                    </Col> 
                                </Row>
                                <Row>
                                <Col>
                                <Row>
                                    <Col>                                            
                                        <Form.Group className="mb-3">
                                        <Form.Label>Sex</Form.Label>
                                        <InputGroup>
                                            <Form.Select                                                 
                                                onChange={(e) => {                                                
                                                    setSex(e.target.value ==  e.target.value == "--Select--" ? undefined : e.target.value)
                                                }}
                                            >                                            
                                            <option>Male</option>
                                            <option>Female</option> 
                                            </Form.Select>                
                                        </InputGroup>
                                        </Form.Group>                                       
                                    </Col>                                                                                            
                                </Row>
                            </Col>
                                </Row>
                                
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                        <Form.Label>Location/Country</Form.Label>
                                        <InputGroup>
                                            <Form.Select onChange={(e) => {                                                
                                                setCountryCode(e.target.value == e.target.value)
                                            }}>
                                            <option value={855}>Cambodia | Global</option>
                                            <option value={86}>China</option>
                                            <option value={66}>Thailand</option>
                                            <option value={84}>Vietnam</option>
                                            </Form.Select>                
                                        </InputGroup>
                                        </Form.Group>                                        
                                    </Col>
                                    {/* <Col flex={10}>    
                                        <Col>
                                            <Form.Label>Phone Number</Form.Label>
                                        </Col>                            
                                        <Col>                                                                            
                                            <InputGroup>
                                                <InputGroup.Text >                                            
                                                    
                                                </InputGroup.Text>
                                                <Form.Control autoFocus required type="text" 
                                                    onChange={onPhoneChange} />
                                            </InputGroup>
                                        </Col>
                                        <Col>
                                            <label className={"text-danger"}>{wrongPhone}</label>
                                        </Col>                                                                                                                      
                                    </Col>                                                                                             */}
                                </Row>   

                                <Row>
                                    <Col>    
                                        <Col>
                                            <Form.Label>Username</Form.Label>
                                        </Col>                            
                                        <Col>                                    
                                            <InputGroup>
                                                <InputGroup.Text >                                            
                                                    <FontAwesomeIcon icon={faUser} />
                                                </InputGroup.Text>
                                                <Form.Control autoFocus required type="text" 
                                                     onChange={(e)=>setUsername(e.target.value)} 
                                                    placeholder="Username"
                                                />
                                            </InputGroup>
                                        </Col>
                                    </Col>                                                                                            
                                </Row>

                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Role</Form.Label>
                                            <InputGroup>
                                                <Form.Select 
                                                    onChange={(e) => {                                                                                                
                                                        setRole(e.target.value ==  e.target.value == "--Select--" ? undefined : e.target.value)
                                                    }}                                                
                                                >                                            
                                                <option>Admin</option>
                                                <option>Super Admin</option>
                                                </Form.Select>                
                                            </InputGroup>
                                        </Form.Group>                                        
                                    </Col>
                                </Row>

                                <Row>
                                    <Col>    
                                        <Col>
                                            <Form.Label>Password</Form.Label>
                                        </Col>                            
                                        <Col>                                    
                                            <InputGroup>
                                                <InputGroup.Text >                                            
                                                    <FontAwesomeIcon icon={faUnlockAlt} />
                                                </InputGroup.Text>
                                                <Form.Control autoFocus required type="password" 
                                                     onChange={(e)=>setPassword(e.target.value)} 
                                                    placeholder="Password"
                                                />
                                            </InputGroup>
                                        </Col>
                                    </Col>                                                                                            
                                </Row>                             
                            </Col>
                            <Col></Col>                                                                            
                        </Row>
                    </Form>

                    <br/>
                    <br/>
                    {
                        progressValue == undefined && (
                            <Form>
                                <Button onClick={onSave}><FontAwesomeIcon icon={faSave} /> Save</Button>
                            </Form>
                        )
                    }
                </Card.Body>                                
                
            </Card>
        </>
    )
}